import { authAPI } from "../../../api/auth";
import { Profile } from "../../../api/auth/myVerifiedProfiles";
import { showErrorToastMsg } from "../../../generic-components/messages/CvpToastMessages";
import { useLocStore } from "../../../localization";
import { redirect } from "../../../url/redirect";
import { path, wsRouteMatch } from "../../../url/WSRouter";

export function associatedReasonExplanation(
  reason: Profile["associatedReason"],
  L: ReturnType<typeof useLocStore>
): string | undefined {
  switch (reason) {
    case "ActiveProfile":
      return L.id("4f1b08a3c92e").loc(
        "Profilen vises fordi du tidligere har aktivert den."
      );
    case "AccountLinkCurrentEmail":
      return L.id("90c3a72e15bd").loc(
        "Profilen vises fordi den er koblet til e-postadressen du er logget inn med."
      );
    case "AccountLinkVerifiedEmail":
      return L.id("21d50bf4a6e7").loc(
        "Profilen vises fordi den er koblet til en e-postadresse du har verifisert."
      );
    case "AccountLinkGuid":
      return L.id("ec47031a5b89").loc(
        "Profilen vises fordi det finnes en eldre kobling til brukeren din."
      );
    default:
      return undefined;
  }
}

export async function activateProfileAndRedirect(
  profile: {
    concernId: number;
    candidateId: number;
  },
  currentPath: string
) {
  await authAPI.setActiveProfile({
    k: profile.concernId,
    candidateId: profile.candidateId,
  });

  let pathname = currentPath;

  if (wsRouteMatch([path("cvpenter")], pathname)) {
    pathname = "profile";
  }

  redirect(pathname, {
    hardRedirect: true,
    mergeQs: {
      k: profile.concernId,
    },
  });
}

// Used by the suggested-placeholder click path: cvpcid points at a candidate
// the IdpUser isn't linked to yet, so we don't know its concernId. After
// (optionally) verifying the email, the backend should have linked the
// candidate — refetch directly (don't trust react-query cache) and activate.
export async function activateByCandidateId(
  candidateId: number,
  currentPath: string,
  L: ReturnType<typeof useLocStore>
): Promise<boolean> {
  const fresh = await authAPI.myVerifiedProfiles({});
  const match =
    fresh?.verifiedProfiles?.find((p) => p.candidateId === candidateId) ??
    fresh?.profileHistory?.find((p) => p.candidateId === candidateId);
  if (!match) {
    showErrorToastMsg(
      L.id("c8a410f37b29").loc(
        "Finner ingen profil med denne kombinasjonen av ID og email."
      )
    );
    return false;
  }
  await activateProfileAndRedirect(match, currentPath);
  return true;
}
